import Quill from 'quill';

/* Este elemento lo estamos usando para poder usar los iframe con la 
version actualizada de Quill. Pasa que la ultima version ya no 
reonoce este elemento y distorsiona su funcoionamiento. */
const BlockEmbed = Quill.import('blots/block/embed') as any;

class IframeBlot extends BlockEmbed {
    static blotName = 'iframe';
    static tagName = 'iframe';

    static create(value: any) {
        const node = super.create() as HTMLElement;
        if (value) {
            Object.keys(value).forEach((key) => {
                node.setAttribute(key, value[key]);
            });
        }
        return node;
    }

    static value(node: HTMLElement) {
        const attributes: any = {};
        Array.from(node.attributes).forEach((attr) => {
            attributes[attr.name] = attr.value;
        });
        return attributes;
    }
}

Quill.register(IframeBlot);
export default IframeBlot;

